import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';
import type {
  FreeToSpend,
  FreeToSpendPatch,
  FreeToSpendPropsImmu,
  PSICreatePayload,
  PlannedSpendingItem,
} from 'app-components/flux/free-to-spend/freeToSpendTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncF2SPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<FreeToSpendPropsImmu>>();
const F2SPayloadCreator = getPayloadCreator<FreeToSpend>();
const PlannedSpendingPayloadCreator = getPayloadCreator<PlannedSpendingItem>();
const batchReleasePayloadCreator = getPayloadCreator<string>();

export const getFreeToSpend = createAction('GET_FREE_TO_SPEND', getPayloadCreator());
export const getFreeToSpendSuccess = createAction('GET_FREE_TO_SPEND_SUCCESS', syncF2SPayloadCreator);
export const getFreeToSpendFailure = createAction('GET_FREE_TO_SPEND_FAILURE', errorPayloadCreator);

export const createFreeToSpend = createAction('CREATE_FREE_TO_SPEND', F2SPayloadCreator);
export const createFreeToSpendSuccess = createAction('CREATE_FREE_TO_SPEND_SUCCESS', F2SPayloadCreator);
export const createFreeToSpendFailure = createAction('CREATE_FREE_TO_SPEND_FAILURE', errorPayloadCreator);

export const updateFreeToSpend = createAction(
  'UPDATE_FREE_TO_SPEND',
  getPayloadCreator<FreeToSpend | FreeToSpendPatch>(),
);
export const updateFreeToSpendSuccess = createAction('UPDATE_FREE_TO_SPEND_SUCCESS', F2SPayloadCreator);
export const updateFreeToSpendFailure = createAction('UPDATE_FREE_TO_SPEND_FAILURE', errorPayloadCreator);

export const updateFreeToSpendOptimistic = createAction('UPDATE_FREE_TO_SPEND_OPTIMISTIC', F2SPayloadCreator);

export const createPlannedSpending = createAction('CREATE_PLANNED_SPENDING', getPayloadCreator<PSICreatePayload>());

export const updatePlannedSpending = createAction('UPDATE_PLANNED_SPENDING', PlannedSpendingPayloadCreator);
export const updatePlannedSpendingSuccess = createAction(
  'UPDATE_PLANNED_SPENDING_SUCCESS',
  PlannedSpendingPayloadCreator,
);
export const updatePlannedSpendingFailure = createAction('UPDATE_PLANNED_SPENDING_FAILURE', errorPayloadCreator);

export const deletePlannedSpending = createAction('DELETE_PLANNED_SPENDING', PlannedSpendingPayloadCreator);
export const deletePlannedSpendingSuccess = createAction(
  'DELETE_PLANNED_SPENDING_SUCCESS',
  PlannedSpendingPayloadCreator,
);
export const deletePlannedSpendingFailure = createAction('DELETE_PLANNED_SPENDING_FAILURE', errorPayloadCreator);

export const deleteFreeToSpend = createAction('DELETE_FREE_TO_SPEND', F2SPayloadCreator);
export const deleteFreeToSpendSuccess = createAction('DELETE_FREE_TO_SPEND_SUCCESS', F2SPayloadCreator);
export const deleteFreeToSpendFailure = createAction('DELETE_FREE_TO_SPEND_FAILURE', errorPayloadCreator);

export const updateFreeToSpendsBump = createAction('UPDATE_FREE_TO_SPEND_BUMP', syncF2SPayloadCreator);
export const doBatchRelease = createAction('DO_BATCH_RELEASE', batchReleasePayloadCreator);
